export const TIPOS_EMISSOES = [
    { label: 'Normal', value: 'NORMAL' }
];

export const TIPOS_EMISSAO_ACOMPANHANTE = [
    { label: 'Acompanhante', value: 'ACOMPANHANTE' },
];

export const TIPOS_EMISSAO_IDOSO_100 = [
    { label: 'ID Idoso 100%', value: 'IDOSO_100' }
];

export const TIPOS_EMISSAO_ID_JOVEM_100 = [
    { label: 'ID Jovem 100%', value: 'ID_JOVEM_100' },
];

export const TIPOS_EMISSAO_CORTESIA = [
    { label: 'Cortesia', value: 'CORTESIA' },
];

export const TIPOS_EMISSAO_P_LIVRE_POLICIAL_AUDITOR = [
    { label: 'P. Livre Policial/Auditor', value: 'P_LIVRE_POLICIAL_AUDITOR' }
];

export const   TIPOS_EMISSOES_COM_GRATUIDADE = [
    { label: 'ID Idoso 50%', value: 'IDOSO_50' },
    { label: 'ID Jovem 50%', value: 'ID_JOVEM_50' },
    { label: 'Deficiente', value: 'DEFICIENTE' }
];

export const TIPOS_EMISSAO_ID_JOVEM_50 = [
    { label: 'ID Jovem 50%', value: 'ID_JOVEM_50' }
];

export const TIPOS_EMISSAO_IDOSO_50 = [
    { label: 'ID Idoso 50%', value: 'IDOSO_50' }
];

export const TIPOS_EMISSAO_DEFICIENTE = [
    { label: 'Deficiente', value: 'DEFICIENTE' }
];      
